export default [
  {
    path: "/funcionario/listagem",
    name: "Listar Funcionários",
    meta: { layout: "default" },
    component: () => import("@/views/tec-ped/funcionario/listar.vue"),
  },
   {
    path: '/funcionario/cadastrar',
    meta: { layout: 'default' },
    name: 'cadastrar_funcionario',
    component: () => import('@/views/tec-ped/funcionario/cadastrar.vue')
  },

   {
    path: '/professor/atribuir-turmas',
    meta: { layout: 'default' },
    name: 'atribuir_turma',
    component: () => import('@/views/tec-ped/funcionario/atribuirTurma.vue')
  },

   {
    path: '/funcionario/menu',
    meta: { layout: 'default' },
    name: 'Menu Funcionario',
    component: () => import('@/views/tec-ped/funcionario/menu.vue')
  },
 
  {
    path: '/professor/listagem',
    meta: { layout: 'default' },
    name: 'Professor na turma',
    component: () => import('@/views/tec-ped/funcionario/professorTurmas.vue')
  },
];
